(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rin-alter-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rin-alter-viewer')) {
  customElements.define('rin-alter-viewer', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const dialog = this.querySelector('.rin-art-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.rin-gallery-image');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.returnTarget = link;
        const image = dialog.querySelector('[data-expanded-image]');
        image.src = link.href;
        image.alt = link.querySelector('img')?.alt || link.dataset.artTitle || '';
        dialog.querySelector('[data-expanded-title]').textContent = link.dataset.artTitle || 'Original artwork';
        const story = link.closest('figure')?.querySelector('.rin-gallery-note');
        const target = dialog.querySelector('[data-expanded-story]');
        target.replaceChildren(...(story ? [...story.childNodes].map(node => node.cloneNode(true)) : []));
        dialog.showModal();
      }, options);
      dialog.querySelector('[data-gallery-back]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        this.returnTarget?.focus({ preventScroll: true });
        dialog.querySelector('[data-expanded-image]').removeAttribute('src');
      }, options);
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
